module.exports = __webpack_public_path__ + "img/BT_language_NO.3105c6e2.svg";